/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsLetterHour: {
  name: 'letter-hour';
  data: string;
} = {
  name: 'letter-hour',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M5.138 7.955v6.136H4V1h1.138v4.813h.102c.23-.507.586-.912 1.068-1.214.485-.303 1.099-.454 1.84-.454.665 0 1.249.136 1.752.409a2.85 2.85 0 0 1 1.176 1.208c.281.533.422 1.189.422 1.969v6.36h-1.144V7.8c0-.81-.226-1.447-.678-1.911-.447-.469-1.052-.703-1.815-.703-.524 0-.991.11-1.4.332-.41.222-.733.541-.972.959-.234.413-.351.906-.351 1.477Z" fill="currentColor"/></svg>`,
};
